import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders,APIURL,JsonURL } from '../common/headers';
import { IUsers } from '../database';
@Injectable()
export class SubjectService {
    private _CountryUrl = JsonURL+'data/countries.json';
    private _StateUrl = JsonURL+'data/countries/';
     private _getSubjectAllUrl = APIURL+'Subject/getAllSubject';
    private _getSubjectUrl = APIURL+'Subject/Subject';
    private _isActivelUrl = APIURL+'Subject/SubjectVerify';
    private _deleteUrl = APIURL+'Subject/deleteSubject';
    private _addUrl = APIURL+'Subject/saveSubject';
    private _getSubjectByUniUrl=APIURL+'Subject/getSubjectsByUniversity';
    private _getSubjectUrlById=APIURL+'Subject/getSubjectsById';
    private _editUrl = APIURL+'Subject/updateSubjectById';
    
    private currentUser :IUsers ; 
    constructor(private _http: Http) { 
           this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
   
    }
    getCountry(): any  {
        return this._http.post(this._CountryUrl,[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getStateByCountry(con:string): any  {
        return this._http.post(this._StateUrl+con+".json",[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    isSubjectActive(SubjectId:string,type): any{
         let formData:FormData = new FormData();
         formData.append('SubjectId', SubjectId);
          formData.append('type', type);
        return this._http.post(this._isActivelUrl,formData )
                            .map((response: Response) => response.json())
                            .catch(this.handleError);
    }
    getAllSubjectsById(Id):any{
        let formData:FormData = new FormData();
         formData.append('SubjectId', Id);
           return this._http.post(this._getSubjectUrlById,formData )
                            .map((response: Response) => response.json().data)
    }
    getAllSubjects():any{
        return this._http.post(this._getSubjectAllUrl,[] )
                            .map((response: Response) => response.json().data)
    }
    getSubjects(userId:any): any{
         let formData:FormData = new FormData();
         formData.append('userId', userId);
        return this._http.post(this._getSubjectUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    edit(form:any,isNew){
         let formData:FormData = new FormData();
         formData.append('SubjectName', form.SubjectName);
         formData.append('UniversityId', form.UniversityId);
         formData.append('SubjectID', form.SubjectID);
         formData.append('isNew', isNew);
        return this._http.post(this._editUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    add(form:any,isNew):any{
           let formData:FormData = new FormData();
         formData.append('SubjectName', form.SubjectName);
         formData.append('UniversityId', form.UniversityId);
         formData.append('isNew', isNew);
            formData.append('userId', this.currentUser.UserId+"");
        return this._http.post(this._addUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    delete(SubjectId): any{
           let formData:FormData = new FormData();
         formData.append('SubjectId',SubjectId);
        return this._http.post(this._deleteUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    getSubjectsByUniversity(university:any): any{
        let formData:FormData = new FormData();
         formData.append('universityId', university);
        return this._http.post(this._getSubjectByUniUrl,formData )
                            .map((response: Response) => response.json().data)
    }
     private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/subject.service.ts